import type { PageContentPayload } from './graph/pageContent.strapi.graphql'


export type DynamicPageContentContextValue = ReturnType<typeof modifyDynamicPageContent>

const modifyDynamicPageContent = (data: PageContentPayload['pages']['data'][number]['attributes']) => {
  if (!data) {
    return null
  }

  const { bodySection, heroSection } = data

  return {
    bodySection,
    heroSection: heroSection?.[0],
  }
}

export default modifyDynamicPageContent
